import { render, staticRenderFns } from "./SubstanceAllergiesTemplate.vue?vue&type=template&id=5941eb7f&scoped=true"
import script from "./SubstanceAllergiesTemplate.vue?vue&type=script&lang=js"
export * from "./SubstanceAllergiesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941eb7f",
  null
  
)

export default component.exports